import React from "react";
import FamilyForm from "../components/FamilyForm/FamilyForm";

function CreateNewFamily() {
  return <FamilyForm />;
}

export default CreateNewFamily;
